import {Component, OnInit} from '@angular/core';
import {DataStorageService} from '../../../../data-storage.service';
import {Internet} from '../../../../../models/internet';
import {PricingService} from '../../../../pricing.service';
import {ApiService} from '../../../../api.service';

@Component({
  selector: 'app-internet',
  templateUrl: './internet.component.html',
  styleUrls: ['./internet.component.scss']
})
export class InternetComponent implements OnInit {

  technologies: string[];
  IPaddress: string[];
  SLAlevel: string[];
  routers: string[];


  constructor(public dataStorageService: DataStorageService,
              private pricing: PricingService,
              private api: ApiService) {

    this.technologies = [];
    this.SLAlevel = [];

    const technologies = new Set();
    this.dataStorageService.ispPricingIPWORLDCOM.map(e => {
      technologies.add(e.technology);
    });
    this.technologies = Array.from(technologies);

    const IPs = new Set();
    this.dataStorageService.addressIPWORLDCOM.map(i => {
      IPs.add(i.option);
    });
    this.IPaddress = Array.from(IPs);

    const SLA = new Set();
    this.dataStorageService.slaIPWORLDCOM.map(l => {
      SLA.add(l.option);
    });
    this.SLAlevel = Array.from(SLA);

    const RT = new Set();
    this.dataStorageService.typeOfRouterIPWORLDCOM.map(r => {
      RT.add(r.option);
    });
    this.routers = Array.from(RT);

  }

  ngOnInit() {
    const offerID = this.dataStorageService.currentState.offerID;
    if (this.dataStorageService.currentState.offerID !== 0) {
      this.api.getInternet(offerID, 'IPWORLDCOM');
    }
  }

  filterbandwidths(tech: string) {
    const filtered = this.dataStorageService.ispPricingIPWORLDCOM.filter((e) => {
      return e.technology === tech;
    });
    const toReturn = new Set();
    filtered.map(e => {
      toReturn.add(e.bandwidth);
    });
    return Array.from(toReturn);
  }

  addInternetConnClick() {
    const dummy: Internet = new Internet();
    dummy.type = 'IPWORLDCOM';
    dummy.technology = this.technologies[0];
    dummy.slaLevel = 'No SLA';
    dummy.bandwidth = this.filterbandwidths(this.technologies[0])[0];
    dummy.router = this.routers[0];
    dummy.ipAddress = this.IPaddress[0];
    dummy.technologyMonthly = this.technologyMonthly(dummy);
    dummy.ipAddressMonthly = this.ipAddressMonthly(dummy);
    dummy.slaLevelMonthly = this.slaLevelMonthly(dummy);
    dummy.routerUnique = this.routerUnique(dummy);
    dummy.totalMonthlyCost = this.calculateTotalMonthly(dummy);
    dummy.totalUniqueCost = this.calculateUnique(dummy);

    this.api.postInternet(this.dataStorageService.currentState.offerID, dummy)
      .then((data) => {
        this.dataStorageService.currentState.PPinternetIPworldcom.internet.push(data);
      });
  }

  removeInternetConnClick(i: number) {
    this.api.deleteInternet(this.dataStorageService.currentState.offerID,
      this.dataStorageService.currentState.PPinternetIPworldcom.internet[i].id).then(() => {
      this.dataStorageService.currentState.PPinternetIPworldcom.internet.splice(i, 1);
    });
  }


  setValue(i: number, event: any, field: string, bandwidth?: string) {
    this.dataStorageService
      .currentState
      .PPinternetIPworldcom
      .internet[i][field] = event.target.value;

    if (field === 'technology') {
      this.dataStorageService
        .currentState
        .PPinternetIPworldcom
        .internet[i]['bandwidth'] = bandwidth;
    }

    const ipworldcomElement = this.dataStorageService.currentState.PPinternetIPworldcom.internet[i];

    ipworldcomElement['technologyMonthly'] = this.technologyMonthly(ipworldcomElement);
    ipworldcomElement['ipAddressMonthly'] = this.ipAddressMonthly(ipworldcomElement);
    ipworldcomElement['slaLevelMonthly'] = this.slaLevelMonthly(ipworldcomElement);
    ipworldcomElement['routerUnique'] = this.routerUnique(ipworldcomElement);
    ipworldcomElement['totalMonthlyCost'] = this.calculateTotalMonthly(ipworldcomElement);
    ipworldcomElement['totalUniqueCost'] = this.calculateUnique(ipworldcomElement);

    this.api.putInternet(this.dataStorageService.currentState.offerID,
      this.dataStorageService.currentState.PPinternetIPworldcom.internet);
  }

  toTranslate(tech: string): string {
    return tech.split(' ')[0];
  }

  techAbbreviation(tech: string): string {
    return tech.split(' ')[1];
  }

  technologyMonthly(i: Internet) {
    const option = this.dataStorageService.ispPricingIPWORLDCOM.filter((e) => {
      return e.technology === i.technology;
    })
      .filter((e) => {
        return e.bandwidth === i.bandwidth;
      });
    return 0 + option[0].monthlyCost;
  }

  ipAddressMonthly(i: Internet): number {
    const ip = this.dataStorageService.addressIPWORLDCOM.filter((e) => {
      return e.option === i.ipAddress;
    });
    return 0 + ip[0].monthlyCost;
  }

  slaLevelMonthly(i: Internet): number {
    const sla = this.dataStorageService.slaIPWORLDCOM.filter((e) => {
      return e.option === i.slaLevel;
    });
    return 0 + sla[0].monthlyCost;
  }

  routerUnique(i: Internet): number {
    const routers = this.dataStorageService.typeOfRouterIPWORLDCOM.filter((e) => {
      return e.option === i.router;
    });
    return 0 + routers[0].uniqueCost;
  }

  calculateTotalMonthly(i: Internet): number {
    const a = this.technologyMonthly(i);
    const b = this.ipAddressMonthly(i);
    const c = this.slaLevelMonthly(i);
    return (a + b + c);
  }

  calculateUnique(i: Internet): number {
    const a = this.routerUnique(i);
    return a;
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/internet-ipworldcom/internet/internet.component.ts